import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import FailureModal from "../../../../Components/Modal/supplier_app/FailureModal";

const COLLECT_CONDITIONS = [
  "Barcode Matched — Good Condition",
  "Barcode Matched — Minor Damage",
  "Barcode Matched — Major Damage",
  "Barcode Not Matching",
];

const QC_CHECKS = [
  { key: "physicalConditionOk", label: "Physical condition checked" },
  { key: "barcodeVerified", label: "Barcode verified and matches" },
  { key: "accessoriesComplete", label: "All accessories present" },
  { key: "cleaningDone", label: "Cleaning / sanitization done" },
  { key: "functionalCheckOk", label: "Functional check passed" },
];

const STOCK_IN_CONDITIONS = [
  "Serviceable — Ready to Rent",
  "Needs Cleaning",
  "Needs Repair",
];

const ClosureItemActionModal = ({ show, onHide, mode, item, onConfirm }) => {
  const [condition, setCondition] = useState("");
  const [remarks, setRemarks] = useState("");
  const [qcChecks, setQcChecks] = useState({});

  const isCollect = mode === "collect";
  const isStockIn = mode === "stockin";
  const allQcDone = QC_CHECKS.every((q) => qcChecks[q.key]);

  const [showFailureModal, setShowFailureModal] = useState(false);
  const [errorFields, setErrorFields] = useState([]);

  const handleSubmit = () => {
    const errors = [];
    if (!condition) errors.push("Please select a condition");
    if (!remarks.trim()) errors.push("Remarks are required");
    if (isStockIn && !allQcDone)
      errors.push("Please complete all quality check items");

    if (errors.length > 0) {
      setErrorFields(errors);
      setShowFailureModal(true);
      return;
    }

    onConfirm({
      remarks,
      condition,
      qualityCheck: isStockIn
        ? { ...qcChecks, checkedAt: new Date().toISOString() }
        : null,
    });
    resetAndClose();
  };

  const resetAndClose = () => {
    setCondition("");
    setRemarks("");
    setQcChecks({});
    onHide();
  };

  const toggleQc = (key) => {
    setQcChecks((prev) => ({ ...prev, [key]: !prev[key] }));
  };

  return (
    <Modal show={show} onHide={resetAndClose} centered size="md">
      {/* ── Header ── */}
      <Modal.Header closeButton className="border-bottom">
        <Modal.Title>
          {isCollect ? "Mark as Collected" : "Stock In & Quality Check"}
        </Modal.Title>
      </Modal.Header>

      {/* ── Body ── */}
      <Modal.Body className="p-4">
        {/* Item Info Strip */}
        <div className="border rounded p-2 text-muted mb-3">
          <strong>Barcode:</strong> {item?.barcode || "—"}
          <span className="mx-2">|</span>
          <strong>Material:</strong> {item?.materialCode}
          <span className="mx-2">|</span>
          <strong>Qty:</strong> {item?.orderedQuantity}
        </div>

        {/* Condition Dropdown */}
        <div className="mb-3">
          <label className="form-label fw-medium mb-1">
            {isCollect ? "Product Condition" : "Stock In Assessment"}
            <span className="text-danger ms-1">*</span>
          </label>
          <select
            className="form-select form-select-sm"
            value={condition}
            onChange={(e) => setCondition(e.target.value)}
          >
            <option value="">Select condition</option>
            {(isCollect ? COLLECT_CONDITIONS : STOCK_IN_CONDITIONS).map(
              (opt) => (
                <option key={opt} value={opt}>
                  {opt}
                </option>
              ),
            )}
          </select>
        </div>

        {/* Quality Check (Stock In Only) */}
        {isStockIn && (
          <div className="border rounded p-3 mb-3">
            <div className="mb-2">
              <span className="fw-semibold text-dark">
                Quality Check <span className="text-danger">*</span>
              </span>
              <span className="text-muted ms-2">(all items mandatory)</span>
            </div>

            {/* Flex Column prevents overlap and stacks checkboxes perfectly */}
            <div className="d-flex flex-column gap-2 mt-2">
              {QC_CHECKS.map((qc) => (
                <div className="form-check m-0" key={qc.key}>
                  <input
                    className="form-check-input"
                    type="checkbox"
                    id={qc.key}
                    checked={qcChecks[qc.key] || false}
                    onChange={() => toggleQc(qc.key)}
                    style={{ cursor: "pointer" }}
                  />
                  <label
                    className="form-check-label text-dark"
                    htmlFor={qc.key}
                    style={{ cursor: "pointer" }}
                  >
                    {qc.label}
                  </label>
                </div>
              ))}
            </div>
          </div>
        )}

        {/* Remarks */}
        <div className="mb-2">
          <label className="form-label fw-medium mb-1">
            Remarks <span className="text-danger ms-1">*</span>
          </label>
          <textarea
            className="form-control form-control-sm"
            rows={3}
            placeholder="Enter remarks..."
            value={remarks}
            onChange={(e) => setRemarks(e.target.value)}
            style={{ resize: "none" }}
          />
        </div>
      </Modal.Body>

      {/* ── Footer ── */}
      <Modal.Footer className="border-top bg-white d-flex justify-content-end gap-2 py-2 px-4">
        <button
          className="btnTable btn-danger"
          onClick={resetAndClose}
          style={{ width: "auto", minWidth: "100px" }}
        >
          Cancel
        </button>
        <button
          className="btnTable"
          onClick={handleSubmit}
          disabled={isStockIn && !allQcDone}
          style={{
            width: "auto",
            minWidth: "140px",
            cursor: isStockIn && !allQcDone ? "not-allowed" : "pointer",
          }}
        >
          {isCollect ? "Confirm Collection" : "Confirm Stock In"}
        </button>
      </Modal.Footer>
      <FailureModal
        show={showFailureModal}
        onHide={() => setShowFailureModal(false)}
        failuremodaldata={{ title: "Validation Error" }}
        requiredfields={errorFields}
      />
    </Modal>
  );
};

export default ClosureItemActionModal;
